module.exports = __webpack_public_path__ + "static/media/math-icon.58d58649.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/courseicons/math-icon.png
// module id = 902
// module chunks = 0